import type { TCargoItemType } from 'api/swagger';

interface IContainerSize {
  length: number;
  width: number;
  height: number;
}

export const CONTAINER_SIZES: Record<TCargoItemType, IContainerSize> = {
  '20DC': { length: 6.06, width: 2.44, height: 2.59 },
  '40DC': { length: 12.19, width: 2.44, height: 2.59 },
  '40HC': { length: 12.19, width: 2.44, height: 2.9 },
  '45HC': { length: 13.72, width: 2.44, height: 2.9 },
};
